import { Text } from '@zinc/ui';

import { computed } from 'mobx';
import { inject, observer } from 'mobx-react';
import React from 'react';
import Badge from './controls/badge';
import Subtitle from './controls/subtitle';

@inject('vm', 'clinicalStore')
@observer
class Title extends React.Component {
  render() {
    return (
      <div className="flex-both nowrap title flex-row">
        <div className="flex-both">
          <Text color="neutral" variant="body-1" weight="bold">
            {this.title}
          </Text>
          <Subtitle />
        </div>
      </div>
    );
  }

  @computed
  get title() {
    let { vm, clinicalStore } = this.props;
    let { status } = vm;
    let { name } = clinicalStore.prontoStore;

    switch (status) {
      case 'warn':
        return 'This report does not exist';
      case 'error':
        return 'There has been a problem loading this report';
      default:
        let text = [name];
        if (this.type) text.push(this.type);
        return text.join(' - ');
    }
  }

  @computed
  get type() {
    let { vm, clinicalStore } = this.props;
    let { report } = vm;
    if (!report) return null;

    switch (report.type) {
      case 0:
        return 'Triage Report';
      case 1:
        return 'Initial Report';
      case 2:
        return 'RFAT Report';
      case 3:
        return 'Discharge Report';
      default:
        let { templates } = clinicalStore.prontoStore;
        let template = templates.get(report.templateId) || {};
        return template.title || 'Unknown Report';
    }
  }
}

export default Title;
